interface NoteSectionProps {
    invoiceData: any
}

export default function NoteSection({ invoiceData }: NoteSectionProps) {
    const note = invoiceData.note;

    if (!note || note.trim() === '') {
        return null;
    }

    return (
        <div className="bg-white p-4 rounded-lg shadow-sm">
            <h2 className="text-md font-medium text-gray-800 mb-3">Note</h2>
            <p className="text-sm text-gray-700 whitespace-pre-wrap">{note}</p>
        </div>
    );
} 